/* global A11Y, CONTENT */
/**
 * @module APP
 * @description Provides the Module system entrypoint and app level scope for 
 * methods that affect the whole application. Called from main.js
 */
;var APP=(function(my){

  my.body=null;
  my.root=null;

  my.init=function(){

    my.body=qs("body");
    my.root=qs("html");
    my.root.removeClass("no-js");
    //initialize various modules and state classes
    initClasses();
    NAVIGATION.init();
    expandCollapseToggleInit();
    AOS.init();
    CONTACT.init();
    VIDEO.init();
    SLIDER.init();
    qsa(".section-index-testimonials .heli-bg").forEach(helibg=>helibg.addClass("animate"));
    adjustIndexPageCaptionLocation();
  };

  /**
   * @method initClasses
   * @description DNT status and support for CSS's `@supports` directive
   * @private
   */
  var initClasses = function() {
    try{
      if (!CSS || !CSS.supports){
        document.querySelector("body").classList.add("no-atsupports-support");
        return {};
      }
    } catch(err){
      document.querySelector("body").classList.add("no-atsupports-support");
      return {};
    }

    my.body.addClass((isDoNotTrackEnabled()?"trackingDisabled":"trackingNotDisabled"));
  };

  /**
   * @method expandCollapseToggleInit
   * @description adds expand/collapse support to paragraph texts inside description-items e.g. on a services page
   * @private
   */
  expandCollapseToggleInit=function(){
    qsa(".description-item .expand-toggle, .description-item .collapse-toggle").forEach(toggle => toggle.addEventListener("click", function(evt){
      evt.target.closest(".description-item").toggleClass("expanded");
    }));
  };

  var adjustIndexPageCaptionLocation = function(){
    if (!my.body.hasClass("index")) {return null;}
    let from=my.body.getAttribute('data-from'); from=parseFloat(from==null?0:from);
    let to=my.body.getAttribute('data-to'); to=parseFloat(to==null?1:to);
    let opts = {
      elem: my.body,
      from: "top-top",
      to: '1000',
      direct: true,
      props: {
        '--v': {
          from: ((from - 1) * 15)+"vw",
          to: ((to - 1) * 15)+"vw",
          timing: function(t){return (Math.round(t*10)/10);}
        }
      },
    };
    return basicScroll.create(opts).start();
  };

  return my;
}(APP || {}));

